import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { PlatformService } from '@core/services/platform/platform.service';

export const appInfoInterceptor: HttpInterceptorFn = (req, next) => {
  const platformService = inject(PlatformService);
  const version = platformService.appVersion();

  req = req.clone({
    setHeaders: {
      'X-Platform': platformService.getPlatform(),
      ...(version && { 'X-App-Version': version }),
    },
  });

  return next(req);
};
